import React, { useLayoutEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { observer, inject } from "mobx-react";
import Container from "@material-ui/core/Container";
import { navigate } from "gatsby";

const InternalForm = inject("store")(
  observer(
    ({
      store: {
        ui: { signedIn }
      },
      children
    }) => {
      useLayoutEffect(() => {
        if (signedIn) {
          navigate("/your-pawns");
        }
      }, [signedIn]);

      return (
        <div className="flexCenter">
          <Container>
            <Grid container spacing={3} alignItems="center" justify="center">
              {!signedIn && (
                <Grid item xs={12} md={6}>
                  {children}
                </Grid>
              )}
            </Grid>
          </Container>
        </div>
      );
    }
  )
);

export default InternalForm;
